export type ShareResult = 'shared' | 'copied'

export async function shareOrCopy({
  title,
  text,
  url,
}: {
  title?: string
  text: string
  url?: string
}): Promise<ShareResult> {
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    const shareData: ShareData = { text }
    if (title) shareData.title = title
    // Some share targets append `url` to `text`, so do not provide it twice.
    if (url && !text.includes(url)) shareData.url = url
    await navigator.share(shareData)
    return 'shared'
  }

  await copyToClipboard(url && !text.includes(url) ? `${text}\n${url}` : text)
  return 'copied'
}

async function copyToClipboard(value: string) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value)
    return
  }

  if (typeof document === 'undefined') {
    throw new Error('Kopiëren is niet beschikbaar in deze browser.')
  }

  const input = document.createElement('textarea')
  input.value = value
  input.setAttribute('readonly', '')
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()

  try {
    if (!document.execCommand('copy')) {
      throw new Error('Kopiëren is niet beschikbaar in deze browser.')
    }
  } finally {
    document.body.removeChild(input)
  }
}
